<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div>
          <ul class="nav nav-pills mb-4" role="tablist" id="v-pills-tab">
            <li class="nav-item mr-2">
              <button
                class="btn btn-outline-primary nav-link"
                v-bind:class="{ active: page == 1 }"
                v-on:click="changePage(1)"
              >
                Question / Response
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 2 }"
                v-on:click="changePage(2)"
              >
                Measurable Outcomes
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 3 }"
                v-on:click="changePage(3)"
              >
                Budget
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 4 }"
                v-on:click="changePage(4)"
              >
                Letters of Support
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 6 }"
                v-on:click="changePage(6)"
              >
                Letters of Inquiry
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 5 }"
                v-on:click="changePage(5)"
              >
                Thank You's
              </button>
            </li>
          </ul>
          <ManageQuestionResponse v-if="page == 1" />
          <ManageMeasurableOutcomes v-if="page == 2" />
          <ManageBudgetTemplates v-if="page == 3" />
          <ManageLettersOfSupport v-if="page == 4" />
          <ManageThankYouLetters v-if="page == 5" />
          <ManageLettersOfInquiry v-if="page == 6" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ManageQuestionResponse from "@/components/ManageTemplates/ManageQuestionResponse.vue";
import ManageLettersOfSupport from "@/components/ManageTemplates/ManageLettersOfSupport.vue";
import ManageMeasurableOutcomes from "@/components/ManageTemplates/ManageMeasurableOutcomes.vue";
import ManageThankYouLetters from "@/components/ManageTemplates/ManageThankYouLetters.vue";
import ManageLettersOfInquiry from "@/components/ManageTemplates/ManageLettersOfInquiry.vue";
import ManageBudgetTemplates from "@/components/ManageTemplates/ManageBudgetTemplates.vue";

export default {
  name: "ManageGrants",
  components: {
    ManageQuestionResponse,
    ManageLettersOfSupport,
    ManageMeasurableOutcomes,
    ManageThankYouLetters,
    ManageBudgetTemplates,
    ManageLettersOfInquiry
  },
  data() {
    return {
      page: 1
    };
  },
  async mounted() {},
  methods: {
    changePage(num) {
      this.page = num;
    }
  }
};
</script>
